import { Component, OnInit } from '@angular/core';
import { TextService } from '../../services/text.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SdkInitText } from 'src/app/model/user/sdk-init-text';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'pa-cvv-info',
  templateUrl: './cvv-info.component.html',
  styleUrls: ['./cvv-info.component.scss']
})
export class CvvInfoComponent implements OnInit {

  textService: TextService;
  trackingId: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private sessionService: SessionService, textService: TextService) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.sessionService.getInitUser(this.trackingId).subscribe(response => {
      this.sdkInitTexts = response.sdkInitTexts;
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

}
